import React, { useState } from 'react'
import { Dialog } from '@e3dc-react/shell/Elements/Dialog'
import { Box, Typography } from '@mui/material'

export interface ShopLeavingConfirmationModalProps {
  title: string
  text: string
  confirmButtonText: string
  cancelButtonText: string
  onClose: () => void
  onConfirm: (onClose: () => void) => void
  place: number
}

/*
 * This Component is Asking if you want to leave the System Configurator.
 */

const ShopLeavingConfirmationModal: React.FC<ShopLeavingConfirmationModalProps> = ({
  place,
  title,
  text,
  confirmButtonText,
  cancelButtonText,
  onClose,
  onConfirm,
}) => {
  /* Loading animation will load when an user has to wait for an async call or function */
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const modalActions = {
    primary: {
      name: confirmButtonText,
      isLoading,
      onClick: () => {
        setIsLoading(true)
        onConfirm(onClose)
      },
    },
    secondary: {
      name: cancelButtonText,
      onClick: () => {
        onClose()
      },
    },
  }

  return (
    <Dialog title={title} maxWidth="xs" place={place} actions={modalActions}>
      <Box sx={{ paddingTop: 2 }}>
        <Typography variant="h4">{text}</Typography>
        <Box sx={{ display: 'flex', justifyContent: 'space-evenly', marginTop: 2 }}></Box>
      </Box>
    </Dialog>
  )
}

export default ShopLeavingConfirmationModal
